import { Tooltip } from '../tooltip/tooltip';
import { OptionsIndicatorConfig } from '@employ-engage/data';
import classNames from 'classnames';

export interface SurveyOptionsIndicatorProps {
  options: OptionsIndicatorConfig[];
}

export const OptionsIndicator = ({ options }: SurveyOptionsIndicatorProps) => {
  return (
    <div className="flex justify-center space-x-1">
      {options.map((option, index) => (
        <div key={index}>
          {option.isActive && (
            <Tooltip label={option.label}>
              <button className="cursor-default">
                <i
                  className={classNames(
                    'fa-solid',
                    option.icon,
                    option.activeColor
                  )}
                />
              </button>
            </Tooltip>
          )}
        </div>
      ))}
    </div>
  );
};

export default OptionsIndicator;
